import {
  userDataCollection,
  usersCollection,
  questionnaireCollection,
  questionsCollection
} from "@/firebase";
import store from "./store";
import { domainToUnicode } from "url";

export default {
  state: {
    studentData: {},
    studentDataLoaded: false,
    teacherDashboard: {
      balli: {
        timepoint1: {},
        timepoint1Averages: {},
        timepoint2: {},
        timepoint2Averages: {}
      },
      bala: {
        descriptions: {},
        descriptionsLoaded: false,
        timepoint1: {
          results: {},
          averages: {},
          completionStatus: {}
        },
        timepoint1Loaded: false,
        timepoint2: {
          results: {},
          averages: {},
          completionStatus: {}
        },
        timepoint2Loaded: false
      }
    },
    studentDashboard: {
      balli: {
        timepoint1: {},
        timepoint1Loaded: false,
        timepoint2: {},
        timepoint2Loaded: false
      },
      bala: {
        descriptions: {},
        descriptionsLoaded: false,
        timepoint1: {
          completionStatus: {},
          results: {},
          averages: {}
        },
        timepoint1Loaded: false,
        timepoint2: {
          completionStatus: {},
          results: {},
          averages: {}
        },
        timepoint2Loaded: false
      }
    }
  },
  getters: {
    teacherDashboard(state: any) {
      return state.teacherDashboard;
    },
    studentData(state: any) {
      return state.studentData;
    },
    studentDataLoaded(state: any) {
      return state.studentDataLoaded;
    },
    studentDashboard(state: any) {
      return state.studentDashboard;
    }
  },
  mutations: {
    addTeacherBalaStudent(state: any, p: { timepoint: number; student: any }) {
      state.teacherDashboard.bala[`timepoint${p.timepoint}`].results[
        `${p.student.id}`
      ] = p.student.data;
    },
    addTeacherBalliStudent(state: any, p: { timepoint: number; student: any }) {
      state.teacherDashboard.balli[`timepoint${p.timepoint}`][
        `${p.student.id}`
      ] = p.student.data;
    },
    markTeacherBalaLoaded(state: any, timepoint: number) {
      state.teacherDashboard.bala[`timepoint${timepoint}Loaded`] = true;
    },
    setBalaStudent(
      state: any,
      p: {
        timepoint: number;
        student: any;
        completionStatus: any;
        averages: any;
      }
    ) {
      state.studentDashboard.bala[`timepoint${p.timepoint}`] = {
        completionStatus: p.completionStatus,
        results: p.student,
        averages: p.averages
      };
    },
    setBalliStudent(state: any, p: { timepoint: number; student: any }) {
      state.studentDashboard.balli[`timepoint${p.timepoint}`] = p.student;
    },
    markStudentBalaLoaded(state: any, timepoint: number) {
      state.studentDashboard.bala[`timepoint${timepoint}Loaded`] = true;
    },
    markStudentDataLoaded(state: any, timepoint: number) {
      state.studentDataLoaded = true;
    },
    markBalaDashboardDescriptionsLoaded(state: any) {
      state.studentDashboard.bala.descriptionsLoaded = true;
      state.teacherDashboard.bala.descriptionsLoaded = true;
    },
    addStudentData(state: any, p: any) {
      state.studentData[p.id] = p.data;
    },
    addStudentBalaCompletionStatusData(
      state: any,
      p: { timepoint: number; data: any; id: string }
    ) {
      state.teacherDashboard.bala[`timepoint${p.timepoint}`][
        "completionStatus"
      ][p.id] = p.data;
    },
    setDashboardDescriptions(
      state: any,
      p: { task: string; isStudent: boolean; data: any }
    ) {
      if (p.isStudent) {
        state.studentDashboard[p.task]["descriptions"] = p.data;
      } else {
        state.teacherDashboard[p.task]["descriptions"] = p.data;
      }
    },
    setAveragesData(
      state: any,
      p: { task: string; timepoint: any; data: any }
    ) {
      state.teacherDashboard[p.task][`timepoint${p.timepoint}`].averages =
        p.data;
    }
  },
  actions: {
    loadDashboardDescriptions({ commit, getters }: any) {
      questionsCollection
        .doc("bala")
        .get()
        .then(doc => {
          let data: any = doc.data();
          if (doc.exists) {
            data = data["dashboardDescriptions"];
            commit("setDashboardDescriptions", {
              task: "bala",
              isStudent: true,
              data: {
                skills: data["students"]["skills"],
                tasks: data["tasks"],
                dashboards: data["students"]["dashboards"]
              }
            });
            commit("setDashboardDescriptions", {
              task: "bala",
              isStudent: false,
              data: {
                skills: data["teachers"]["skills"],
                tasks: data["tasks"],
                dashboards: data["teachers"]["dashboards"]
              }
            });
          }
        })
        .then(() => {
          commit("markBalaDashboardDescriptionsLoaded");
        });
    },
    loadStudentData({ commit, getters }: any, teacherId: string) {
      usersCollection
        .where("teacherid", "==", teacherId)
        .get()
        .then((snapshot: any) => {
          if (snapshot) {
            let promises: any = [];
            snapshot.forEach(function(doc: any) {
              let data: any = doc.data();
              let uid = doc.id;
              let timepoint = getters.balaTimepoint;
              commit("addStudentData", { id: uid, data: data });

              // get bala student completion data
              promises.push(
                userDataCollection
                  .doc(uid)
                  .collection("bala")
                  .doc(`timepoint${timepoint}`)
                  .get()
                  .then(doc => {
                    if (doc.exists) {
                      let data: any = doc.data();
                      commit("addStudentBalaCompletionStatusData", {
                        timepoint: timepoint,
                        id: uid,
                        data: data["completionStatus"]
                      });
                      Promise.resolve();
                    }
                  })
              );
            });

            return Promise.all(promises);
          } else {
            Promise.reject();
          }
        })
        .then(() => {
          commit("markStudentDataLoaded");
        });
    },
    loadBalaAveragesData(
      { commit, state, getters }: any,
      p: { uid: string; timepoint: number; teacherId: string }
    ) {
      let uid = p.uid;
      let timepoint = p.timepoint;
      var teacherId = p.teacherId;

      if (teacherId == null) {
        // student is not affiliated with school
        commit("setAveragesData", {
          task: "bala",
          timepoint: timepoint,
          data: {
            explicit: 0,
            inferencing: 0,
            discourse: 0,
            overall: 0
          }
        });

        return;
      }

      userDataCollection
        .doc(teacherId)
        .collection("bala")
        .doc(`timepoint${timepoint}`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let data: any = doc.data();
            if (
              data["averages"] == undefined ||
              Object.keys(data["averages"]).length == 0
            )
              return Promise.reject();
            commit("setAveragesData", {
              task: "bala",
              timepoint: timepoint,
              data: data["averages"]
            });
            // alert(JSON.stringify(getters.teacherDashboard.bala.timepoint1Averages))
          }
        })
        .catch(() => {
          commit("setAveragesData", {
            task: "bala",
            timepoint: timepoint,
            data: {
              explicit: 0,
              inferencing: 0,
              discourse: 0,
              overall: 0
            }
          });
        })
        .then(() => {
          commit("markStudentBalaLoaded", timepoint);
        });
    },
    loadBalliAveragesData(
      { commit, state, getters }: any,
      p: { uid: string; timepoint: number }
    ) {
      let uid = p.uid;
      let timepoint = p.timepoint;
      var teacherId = "";

      usersCollection
        .doc(uid)
        .get()
        .then(doc => {
          if (doc.exists) {
            teacherId = (doc.data() as any)["teacherid"];
          }
        })
        .then(() => {
          userDataCollection
            .doc(teacherId)
            .collection("balli")
            .doc(`timepoint${timepoint}`)
            .get()
            .then(doc => {
              if (doc.exists) {
                let data: any = doc.data();
                if (data["averages"] == undefined) return;
                commit("setAveragesData", {
                  task: "balli",
                  timepoint: timepoint,
                  data: data["averages"]
                });
                // alert(JSON.stringify(getters.teacherDashboard.bala.timepoint1Averages))
              }
            })
            .then(() => {
              commit("markStudentBalliLoaded", timepoint);
            });
        });
    },
    loadTeacherBalaData(
      { commit, state }: any,
      p: { uid: string; timepoint: number }
    ) {
      let uid = p.uid;
      let timepoint = p.timepoint;

      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(`timepoint${timepoint}`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let data: any = doc.data();
            if (
              data["averages"] == undefined ||
              data["students"] == undefined ||
              Object.keys(data["averages"]).length == 0 ||
              Object.keys(data["students"]).length == 0
            ) {
              return Promise.reject();
            }
            Object.keys(data["students"]).forEach((key: any) => {
              commit("addTeacherBalaStudent", {
                timepoint: timepoint,
                student: { id: key, data: data["students"][key] }
              });
            });
            commit("setAveragesData", {
              task: "bala",
              timepoint: timepoint,
              data: data["averages"]
            });
          }
        })
        .then(() => {
          commit("markTeacherBalaLoaded", timepoint);
        });
    },
    loadTeacherBalliData(
      { commit, state }: any,
      p: { uid: string; timepoint: number }
    ) {
      let uid = p.uid;
      let timepoint = p.timepoint;

      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(`timepoint${timepoint}`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let data: any = doc.data();
            if (data["averages"] == undefined || data["students"] == undefined)
              return;
            Object.keys(data["students"]).forEach((key: any) => {
              commit("addTeacherBalliStudent", {
                timepoint: timepoint,
                student: { id: key, data: data["students"][key] }
              });
            });
            commit("setAveragesData", {
              task: "balli",
              timepoint: timepoint,
              data: data["averages"]
            });
          }
        })
        .then(() => {
          commit("markTeacherBalaLoaded", timepoint);
        });
    },
    loadStudentBalaData(
      { commit, getters }: any,
      p: { uid: string; timepoint: number; teacherId: string }
    ) {
      let uid = p.uid;
      let timepoint = p.timepoint;

      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(`timepoint${timepoint}`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let data: any = doc.data();
            if (data["results"] == undefined) {
              return Promise.reject();
            }
            commit("setBalaStudent", {
              timepoint: timepoint,
              student: data["results"],
              averages: data["averages"],
              completionStatus: data["completionStatus"]
            });
          }
        })
        .then(() => {
          store.dispatch("loadBalaAveragesData", p);
        });
    },
    loadStudentBalliData(
      { commit, getters }: any,
      p: { uid: string; timepoint: number }
    ) {
      let uid = p.uid;
      let timepoint = p.timepoint;

      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(`timepoint${timepoint}`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let data: any = doc.data();
            if (data["results"] == undefined) return;
            commit("setBalliStudent", {
              timepoint: timepoint,
              student: data["results"]
            });
          }
        })
        .then(() => {
          store.dispatch("loadBalliAveragesData", p);
        });
    }
  }
};
